import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "../blogs/BlogPage.scss";

import { getSolarSystemInfo } from "store/ourProjects/ourProjects.slice";
import { formatDate } from "utils/helpers/dateTime";
import ShareIcons from "components/shareIcons/ShareIcons";
import PhotoGallery from "components/photo/PhotoGallery";
import { useLocation } from "react-router-dom";
import BlogPage from "../blogs/BlogPage";
import CategoriesPage from "../categories/CategoriesPage";
import RecentArticles from "../recentArticles/RecentArticles";
import { useTranslation } from "react-i18next";
import { setSEO } from "utils/helpers/seo-function";
import { BASE_URL } from "config/constants";

const OurProjects = () => {
  const { solarSystemInfo } = useSelector((store: any) => store.ourProjects);
  const menu = useSelector((store: any) => store.articleCategory);
  const dispatch: any = useDispatch();
  const { t } = useTranslation("home", { useSuspense: false });
  const { pathname } = useLocation();
  const getCurrentCategoryName = () => {
    return "Solarne elektrane, ključ u ruke i oprema za elektrane";
  };

  useEffect(() => {
    dispatch(getSolarSystemInfo(null));
  }, [dispatch]);

  useEffect(() => {
    if (solarSystemInfo.is_fetch === true) {
      setSEO({
        title: solarSystemInfo.data.post_title,
        description: solarSystemInfo.data.post_description,
        keywords:
          solarSystemInfo.data.seo_keywords !== null
            ? solarSystemInfo.data.seo_keywords
            : [],
        url: BASE_URL + pathname,
        image:
          solarSystemInfo.data.images.length !== 0
            ? solarSystemInfo.data.images[0]
            : "",
        type: "our-projects",
      });
    }
  }, [solarSystemInfo.is_fetch]);

  return (
    <>
      <div className="Page">
        <div className="Page-Content">
          {solarSystemInfo.is_fetch && (
            <>
              <h2 className="Page-Title">{solarSystemInfo.data.post_title}</h2>
              <div className="Blog-Detail-Row">
                <div className="Blog-Detail-1">
                  <label className="Blog-Detail-Date">
                    {formatDate(solarSystemInfo.data.created_at)}
                  </label>
                  <p className="Blog-Mini-Desc">
                    {solarSystemInfo.data.post_description}
                  </p>
                  <div
                    className="Blog-Detail-Content"
                    dangerouslySetInnerHTML={{
                      __html: solarSystemInfo.data.post_content,
                    }}
                  />
                  {solarSystemInfo.data.video_url && (
                    <div className="Blog-Detail-Videos">
                      <iframe
                        title={solarSystemInfo.data.video_url}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        src={solarSystemInfo.data.video_url}
                        className="Blog-Detail-Video"
                      ></iframe>
                    </div>
                  )}
                  <div className="Blog-Detail-Share">
                    <ShareIcons
                      url={pathname}
                      title={solarSystemInfo.data.post_title}
                      summary={solarSystemInfo.data.post_description}
                    />
                  </div>
                </div>
                <div className="Blog-Detail-2">
                  <div className="Blog-Detail-Photos">
                    {solarSystemInfo.data.images.length !== 0 && (
                      <PhotoGallery
                        images={solarSystemInfo.data.images}
                        type={"blog"}
                      />
                    )}
                  </div>
                  <div
                    className="Blog-Detail-Content"
                    dangerouslySetInnerHTML={{
                      __html: solarSystemInfo.data.post_content,
                    }}
                  />
                  {solarSystemInfo.data.video_url && (
                    <div className="Blog-Detail-Videos">
                      <iframe
                        title={solarSystemInfo.data.video_url}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        src={solarSystemInfo.data.video_url}
                        className="Blog-Detail-Video"
                      ></iframe>
                    </div>
                  )}
                  <div className="Blog-Detail-Share">
                    <ShareIcons
                      url={pathname}
                      title={solarSystemInfo.data.post_title}
                      summary={solarSystemInfo.data.post_description}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <BlogPage />
      <div className="Page">
        <div className="Page-Content">
          <CategoriesPage
            cat1={"solarne-elektrane-kljuc-u-ruke-i-oprema-za-elektrane"}
            cat3={undefined}
            menu={menu}
            getCurrentCategoryName={getCurrentCategoryName}
          />
          <RecentArticles
            slug={"solarne-elektrane-kljuc-u-ruke-i-oprema-za-elektrane"}
            title={"Najpopularniji proizvodi"}
          />
        </div>
      </div>
    </>
  );
};
export default OurProjects;
